import { STATUS_LOAN } from "#colaborador/Solicitudes/constants"
import ButtonIcon from "#common/buttons/ButtonIcon"
import { InputDate } from "#common/input/InputDate"
import PERMISOS from "#constants/perfiles"
import { DialogMaster } from "#core/components/dialog/Dialog"
import InputFilePDF from "#core/components/input/file/InputFilePDF"
import InputNumber from "#core/components/input/number/InputNumber"
import { useApiSend } from "#hooks/useApiSend"
import { UseHasPermission } from "#hooks/useHasPermission"
import { loanIdPut } from "#loan/services/api"
import NoteAddIcon from "@mui/icons-material/NoteAdd"
import { Box } from "@mui/material"
import { Fragment, useCallback, useState } from "react"
import { toast } from "react-toastify"

export default function LoanStatusAwaitedDocument({ setValue, value }) {
	return (
		<Box sx={{ display: "grid", gap: 2 }}>
			<InputNumber
				label="Interés del préstamo % "
				value={value?.interest}
				endIcon
				setValue={(interest) => setValue({ ...value, interest })}
			/>

			<InputDate
				label="Fecha de pago"
				value={value?.day_payment}
				onChange={(date) => setValue({ ...value, day_payment: date })}
				fullWidth
			/>
			<InputFilePDF
				label="Subir Calculo"
				value={value?.calculo}
				setValue={(calculo) => setValue({ ...value, calculo })}
			/>
		</Box>
	)
}

export const LoanStatusAwaitedDocumentDialog = ({ id, loan, reload }) => {
	const [data, setData] = useState({})
	const [open, setOpen] = useState(false)
	const [disabled, setDisabled] = useState(false)

	const success = () => {
		reload()
		setOpen(false)
	}
	const end = () => {
		setDisabled(false)
	}
	const { fetch } = useApiSend(loanIdPut, { success, end })

	const handleSubmit = useCallback(() => {
		let data_send = {
			status: STATUS_LOAN.AWAITED_DOCUMENT,
			...data,
		}
		if (data_send.interest > 100 || data_send.interest < 0) {
			toast.error("El interés debe estar entre 0% y 100%")
			return
		}

		if (data_send.day_payment.isValid())
			data_send.day_payment = data_send.day_payment.toISOString()

		const formData = new FormData()
		Object.keys(data_send).forEach((key) => {
			if (data_send[key] !== undefined) {
				formData.append(key, data_send[key])
			}
		})

		setDisabled(true)
		fetch(id, formData)
	}, [data, fetch, id])

	const isRh = UseHasPermission(PERMISOS.RH)

	if (!isRh) return null
	if (loan?.status !== STATUS_LOAN.VALIDATE_BOSS) return null

	return (
		<Fragment>
			<ButtonIcon
				icon={<NoteAddIcon />}
				onClick={() => setOpen(true)}
				color="success"
				title="subir calculo"
			/>

			<DialogMaster
				{...{
					open,
					setOpen,
					title: "Subir cálculo ",
					handleSubmit: handleSubmit,
					maxWidth: "sm",
					disabled,
				}}
			>
				<LoanStatusAwaitedDocument
					id={id}
					value={data}
					setValue={setData}
					autoFetch={open}
				/>
			</DialogMaster>
		</Fragment>
	)
}
